import { AuthClient } from "@api/apiClient";
import axios from "@api/axiosInstance";
import FullPageLoading from "@components/FullPageLoading";
import useAppStore from "@hooks/useAppStore";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const authClient = new AuthClient(undefined, axios);

const LogoutPage = observer(() => {
  const appStore = useAppStore();
  const navigate = useNavigate();

  useEffect(() => {
    async function logout() {
      try {
        await authClient.signOutCurrentUserGET();

        // TODO: must clear server side session/cookie
        // TODO: must clear server side session/cookie
        // TODO: must clear server side session/cookie

        // TODO: make logout method
        await appStore.queryClient.resetQueries({ queryKey: ["userProfile"], exact: false });
        appStore.isAuthenticated = false;
        appStore.setUserProfile(null);
        // TODO: make logout method

        appStore.viewerToken.setToken(null);

        // TODO: move these to appStore
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        // TODO: move these to appStore

        navigate("/");
        navigate(0);
      } catch (err) {
        console.log(err);
      }
    }

    logout();
  }, []);

  return <FullPageLoading />;
});

export default LogoutPage;
